import AdaptiveImage from "../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "f3db18c9979f3370e5497faabc62902a.png",
    width: 825,
    height: 1703
});